module.exports = __webpack_public_path__ + "static/img/88-1.087317f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/88-1.jpg
// module id = zFK0
// module chunks = 0